import React from 'react'
import { useNavigate } from 'react-router-dom'
import { forgotPasswordApi } from '../../Context/api';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import { statusCodes, commonMessage } from "../../Constants/generalConfig";
import { useFormik } from 'formik';
import { forgotPinValidation } from '../../Context/validation';
import ValidationMessage from '../../Component/validationMessage';


const ForgotPin = () => {
    const navigate = useNavigate()
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const forgotPinWithEmail = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: forgotPinValidation,
        onSubmit: values => {

            axios.post(forgotPasswordApi(), { ...values, timeZone: timeZone, roleTitle: 'ADMIN' }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                }
                else if (resp.data.code === 410) {
                    localStorage.setItem("email", JSON.stringify(values.email));
                    toast.success(resp.data.message)
                    setTimeout(() => {
                        navigate('/verifyOtp')
                    }, 2000);
                }

                else {
                    toast.error(resp.data.message)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                })
        },
    });
    return (
        <>
            <ToastContainer />
            <section className="bg_img">
                <section>
                    <div className="col-lg-12">
                        <div className="container">
                            <div className="col-lg-10 mx-auto">
                                <div className="row" style={{ padding: '16% 0' }}>
                                    <div className="col-lg-6 bg_color border_reduas padd_img d-flex justify-content-center">
                                        <img src={require('../../Assets/images/Forgot_img.jpg')} className="border_reduas_2" alt="" />
                                    </div>
                                    <div className="col-lg-6 bg_white border_reduas_1 p-5">
                                        <div className="ps-4 pt-5">
                                            <h1 className="heading_color">Forgot Pin?</h1>
                                            <div className="pt-4">
                                                <div className="input-group mb-4">
                                                    <span className="input-group-text" id="basic-addon1"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                                                        <path fill="#F47E3B" d="M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m0 2l-6.5 4.47a1 1 0 0 1-1 0L5 6Z" />
                                                    </svg>
                                                    </span>
                                                    <input type="email" placeholder='Email' name="email" className="form-control form-control_Style" onChange={forgotPinWithEmail.handleChange}
                                                        onBlur={forgotPinWithEmail.handleBlur} value={forgotPinWithEmail.values.email} />
                                                        <ValidationMessage name='email' formName={forgotPinWithEmail} />
                                                </div>
                                                <div className="pt-4">
                                                    <button className="my_btn" onClick={forgotPinWithEmail.handleSubmit}>Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </>
    )
}

export default ForgotPin;